/* ag-cart-feedback.js — muestra "Agregando…" / "¡Agregado!" en el botón principal de la ficha de producto.
   Falla en silencio si algo no existe. No modifica el flujo de carrito (tema + Essential Cart Drawer). */
(function () {
  'use strict';
  function init() {
    if (!document.body.classList.contains('template-product')) return;
    var info = document.querySelector('product-info');
    var form = info && info.querySelector('[data-product-form]');
    var btn = form && form.querySelector('[data-add-to-cart]');
    if (!btn) return;

    var state = document.createElement('span');
    state.className = 'ag-btn-state';
    state.setAttribute('role', 'status');
    btn.appendChild(state);

    var failsafe, clearT;
    function isDisabled() {
      return btn.disabled || btn.getAttribute('aria-disabled') === 'true';
    }
    function setState(s) {
      clearTimeout(failsafe);
      clearTimeout(clearT);
      if (s) {
        btn.setAttribute('data-ag-state', s);
        state.textContent = s === 'loading' ? 'Agregando…' : '¡Agregado!';
        failsafe = setTimeout(function () { setState(null); }, 10000);
      } else {
        btn.removeAttribute('data-ag-state');
        state.textContent = '';
      }
    }

    btn.addEventListener('click', function () {
      if (!isDisabled()) setState('loading');
    }, true);
    document.addEventListener('theme:product:add-error', function () { setState(null); });

    /* Fin de la petición /cart/add -> check breve (o limpiar si falló) */
    if ('PerformanceObserver' in window) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (en) {
            if (en.name.indexOf('/cart/add') === -1) return;
            if (en.responseStatus && en.responseStatus >= 400) { setState(null); return; }
            if (!btn.hasAttribute('data-ag-state')) return;
            setState('added');
            clearT = setTimeout(function () { setState(null); }, 1400);
          });
        }).observe({ type: 'resource', buffered: false });
      } catch (e) {}
    }

    /* Al abrir cualquier cajón, limpiar el estado */
    var root = document.documentElement;
    try {
      new MutationObserver(function () {
        if (/essential-cart__open|js-drawer-open/.test(root.className) && btn.hasAttribute('data-ag-state')) {
          clearT = setTimeout(function () { setState(null); }, 300);
        }
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }
  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) { if (window.console) console.warn('[ag-cart-feedback]', e); }
})();
